import { useIsShowingV4 } from 'hooks/useV4';

/** Must be called inside a versioned route: the v4 check reads `ver` from the URL params. */
export const useIsDatasetComparisonEnabled = (): boolean => !useIsShowingV4();
